/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWGame } from './OWGame';
import {
    OWGameFromJSON,
    OWGameFromJSONTyped,
    OWGameToJSON,
    OWGameToJSONTyped,
} from './OWGame';
import type { OWReward } from './OWReward';
import {
    OWRewardFromJSON,
    OWRewardFromJSONTyped,
    OWRewardToJSON,
    OWRewardToJSONTyped,
} from './OWReward';
import type { OWClaimLog } from './OWClaimLog';
import {
    OWClaimLogFromJSON,
    OWClaimLogFromJSONTyped,
    OWClaimLogToJSON,
    OWClaimLogToJSONTyped,
} from './OWClaimLog';
import type { OWLogCategory } from './OWLogCategory';
import {
    OWLogCategoryFromJSON,
    OWLogCategoryFromJSONTyped,
    OWLogCategoryToJSON,
    OWLogCategoryToJSONTyped,
} from './OWLogCategory';

/**
 * Collection contains the user's reward stats/progress.
 * @export
 * @interface OWUserStat
 */
export interface OWUserStat {
    /**
     * The ID of the user for which this reward is applicable.
     * @type {string}
     * @memberof OWUserStat
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof OWUserStat
     */
    gameId?: string;
    /**
     * 
     * @type {OWGame}
     * @memberof OWUserStat
     */
    game?: OWGame;
    /**
     * Whether the game-based reward has been claimed.
     * @type {boolean}
     * @memberof OWUserStat
     */
    isClaimed?: boolean;
    /**
     * 
     * @type {OWReward}
     * @memberof OWUserStat
     */
    reward: OWReward;
    /**
     * 
     * @type {OWLogCategory}
     * @memberof OWUserStat
     */
    rewardCategory: OWLogCategory;
    /**
     * The progress towards the target.
     * @type {number}
     * @memberof OWUserStat
     */
    progress: number;
    /**
     * The target to reach to claim the reward.
     * @type {number}
     * @memberof OWUserStat
     */
    target: number;
    /**
     * The UNIX timestamp of the start of the week (Mon 12AM EST)
     * @type {number}
     * @memberof OWUserStat
     */
    weekStart?: number;
    /**
     * The progress towards the target for the current week.
     * @type {number}
     * @memberof OWUserStat
     */
    weeklyProgress?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OWUserStat
     */
    isWeeklyLimitFeedbackDismissed?: boolean;
    /**
     * 
     * @type {Array<OWClaimLog>}
     * @memberof OWUserStat
     */
    claimLogs?: Array<OWClaimLog>;
    /**
     * The UNIX timestamp when the monthly quest stats was last reset via the cron job.
     * @type {Date}
     * @memberof OWUserStat
     */
    lastStatReset?: Date;
    /**
     * The timestamp when the event was created.
     * @type {Date}
     * @memberof OWUserStat
     */
    createdAt: Date;
    /**
     * The timestamp when the event was last updated.
     * @type {Date}
     * @memberof OWUserStat
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof OWUserStat
     */
    id: string;
}



/**
 * Check if a given object implements the OWUserStat interface.
 */
export function instanceOfOWUserStat(value: object): value is OWUserStat {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('reward' in value) || value['reward'] === undefined) return false;
    if (!('rewardCategory' in value) || value['rewardCategory'] === undefined) return false;
    if (!('progress' in value) || value['progress'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function OWUserStatFromJSON(json: any): OWUserStat {
    return OWUserStatFromJSONTyped(json, false);
}

export function OWUserStatFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWUserStat {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'game': json['game'] == null ? undefined : OWGameFromJSON(json['game']),
        'isClaimed': json['isClaimed'] == null ? undefined : json['isClaimed'],
        'reward': OWRewardFromJSON(json['reward']),
        'rewardCategory': OWLogCategoryFromJSON(json['rewardCategory']),
        'progress': json['progress'],
        'target': json['target'],
        'weekStart': json['weekStart'] == null ? undefined : json['weekStart'],
        'weeklyProgress': json['weeklyProgress'] == null ? undefined : json['weeklyProgress'],
        'isWeeklyLimitFeedbackDismissed': json['isWeeklyLimitFeedbackDismissed'] == null ? undefined : json['isWeeklyLimitFeedbackDismissed'],
        'claimLogs': json['claimLogs'] == null ? undefined : ((json['claimLogs'] as Array<any>).map(OWClaimLogFromJSON)),
        'lastStatReset': json['lastStatReset'] == null ? undefined : (new Date(json['lastStatReset'])),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'id': json['id'],
    };
}

export function OWUserStatToJSON(json: any): OWUserStat {
    return OWUserStatToJSONTyped(json, false);
}

export function OWUserStatToJSONTyped(value?: OWUserStat | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'gameId': value['gameId'],
        'game': OWGameToJSON(value['game']),
        'isClaimed': value['isClaimed'],
        'reward': OWRewardToJSON(value['reward']),
        'rewardCategory': OWLogCategoryToJSON(value['rewardCategory']),
        'progress': value['progress'],
        'target': value['target'],
        'weekStart': value['weekStart'],
        'weeklyProgress': value['weeklyProgress'],
        'isWeeklyLimitFeedbackDismissed': value['isWeeklyLimitFeedbackDismissed'],
        'claimLogs': value['claimLogs'] == null ? undefined : ((value['claimLogs'] as Array<any>).map(OWClaimLogToJSON)),
        'lastStatReset': value['lastStatReset'] == null ? undefined : ((value['lastStatReset']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'id': value['id'],
    };
}

